import {management} from '../../../..'

import {logValveRepository} from '../../../infra/knex/repositories/logValveRepository'
import {ShowLastRecordValveUseCase} from './showLastRecordUseCase'


export const showLasRecord=new ShowLastRecordValveUseCase(new logValveRepository(management))
